import { faGraduationCap } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
const educations = [
    { date: "2022 - Now", institution: 'Jahangirnagar University', place: 'Savar, Dhaka ', subject: 'M.Sc in Information Technology', },
    { date: "2018 - 2022", institution: 'Daffodil International University', place: 'Ashulia, Dhaka ', subject: 'B.Sc in Computer Science and Engineering', },
    { date: "2015 - 2017", institution: 'Pangsha Government College', place: 'Pangsha, Rajbari ', subject: 'Higher Secondary in Science', },
    { date: "2009 - 2015", institution: 'Al-haj Amena Khatun Biddyapith', place: 'Kalukhali, Rajbari ', subject: 'Secondary  in Science', }
];
const EducationalInfo = () => {
    return (
        <div className="flex-1  ">
            <h2><FontAwesomeIcon className='text-blue-400' icon={faGraduationCap} /> Education</h2>
            {educations.map((education, index) => (
                <div key={index} className="w-full pr-2">
                    <div className=" p-6 mt-4 bg-white border border-gray-200 rounded-lg shadow-2xl hover:border-blue-700 ">
                        <p className='text-xs '> <span className='border border-blue-300'>{education.date}</span></p>
                        <p className='text-xl'>{education.institution}</p>
                        <p className='font-thin'>{education.place}</p>
                        <p>{education.subject}</p>

                    </div>
                </div>
            ))}
        </div>
    );
};

export default EducationalInfo;